import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { ApiError } from '@/api/types';
import { Case } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetCase = (caseId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Case>(
    [QueryEntity.Case, caseId],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/case/${caseId}`, fetchConfigGET);
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!caseId,
    },
  );
};
